import { useCallback } from 'react';
import { Map as ImmutableMap } from 'immutable';
import { ProductsEditorIFrameModal } from 'products-iframe-lib/components/ProductsEditorIFrameModal';
import { useDeleteProductAction } from '../contexts/DeleteProductActionContext';
import { useProductData } from '../contexts/ProductDataContext';
import { useProductDeleteModal } from '../contexts/ProductDeleteModalContext';
import { useProductEditModal } from '../contexts/ProductEditModalContext';
import { useUpdateProductAction } from '../contexts/UpdateProductActionContext';
import { DeleteProductModal } from './DeleteProductModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ProductHighlightModals = () => {
  const product = useProductData();
  const deleteProduct = useDeleteProductAction();
  const {
    isDeleteModalOpen,
    setIsDeleteModalOpen
  } = useProductDeleteModal();
  const {
    isEditModalOpen,
    setIsEditModalOpen
  } = useProductEditModal();
  const updateProduct = useUpdateProductAction();
  const handleCloseDeleteModal = useCallback(() => {
    setIsDeleteModalOpen(false);
  }, [setIsDeleteModalOpen]);
  const handleIframeMessage = useCallback(({
    payload
  }) => {
    switch (payload.type) {
      case 'PRODUCT_UPDATE_COMPLETE':
        updateProduct(ImmutableMap(payload.updatedProperties.entries()));
        break;
      case 'EXIT':
        setIsEditModalOpen(false);
        break;
      default:
        break;
    }
  }, [setIsEditModalOpen, updateProduct]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isDeleteModalOpen && /*#__PURE__*/_jsx(DeleteProductModal, {
      onConfirm: deleteProduct,
      onReject: handleCloseDeleteModal
    }), (product === null || product === void 0 ? void 0 : product.objectId) != null && /*#__PURE__*/_jsx(ProductsEditorIFrameModal, {
      show: isEditModalOpen,
      operation: "EDIT",
      objectId: product.objectId,
      onMessage: handleIframeMessage
    })]
  });
};